import dataEngine from '@/lib/engine';
import * as types from '@/store/mutationTypes';
import content from '../../../api/content';

function loadSingleTOC({ commit }, moduleId) {
  dataEngine.loadSingleTOCFromServer(commit, moduleId);
}

function loadAllTOC({ commit }) {
  commit(types.SET_TOC_STATE, dataEngine.MANAGER_STATE.STATE_LOADING);
  dataEngine.loadTOCFromServer(commit);
}

async function loadAllTOCAsync({ commit }) {
  commit(types.SET_TOC_STATE, dataEngine.MANAGER_STATE.STATE_LOADING);
  await dataEngine.loadTOCFromServerAsync(commit);
}

function updateModules({ commit }, modules) {
  dataEngine.addModules(commit, modules);
}

function dataManagerSetup({ commit }, init) {
  dataEngine.initial(commit, init);
}

function updateModuleProp({ commit }, prop) {
  dataEngine.updateSingleModule(prop.id, prop.type, prop.value);
  commit(types.SET_MODULE_STATE, dataEngine.MANAGER_STATE.STATE_UPDATED);
}

function updateSingleModule({ commit }, module) {
  dataEngine.addSingleModule(commit, module);
  dataEngine.loadSingleTOCFromServer(commit, module.id);

  commit(types.SET_MODULE_STATE, dataEngine.MANAGER_STATE.STATE_UPDATED);
}

async function getPageHistory({ commit }, details) {
  const response = await content.getPageHistory(details.moduleId, details.pagePath);
  commit(types.PAGE_HISTORY, response.data);
}

async function setPageCommitOID({ commit }, oid) {
  commit(types.DATA_SET_PAGE_COMMIT_OID, oid);
}

async function setPageCommitTimestamp({ commit }, timestamp) {
  commit(types.DATA_SET_PAGE_COMMIT_OID, timestamp);
}

export default {
  loadSingleTOC,
  loadAllTOC,
  loadAllTOCAsync,
  updateModules,
  dataManagerSetup,
  updateModuleProp,
  updateSingleModule,
  getPageHistory,
  setPageCommitOID,
  setPageCommitTimestamp
};
